import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Años sintiendo el llamado sin dar el paso', 'Cursos sueltos que no conectan entre sí', 'Sin certificado oficial que respalde lo que sabés', 'Protocolos de sintonización que nadie te enseñó paso a paso', 'Querés enseñar pero no sabés cómo iniciar a tus alumnos', 'Podés cobrar por esto pero no tenés la estructura para animarte'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-white/5" data-id="element-385">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-386">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-387">
          <div className="text-center mb-10" data-id="element-388">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-white" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-389">
              ¿Cuánto tiempo más vas a postergar esto?
            </h2>
            <div className="text-lg md:text-xl text-gray-300 space-y-4 font-medium" data-id="element-390">
              <p data-id="element-391">
                Sentís el llamado del Reiki hace tiempo. Tal vez años. Pero
                nunca encontraste una formación completa, seria y accesible en
                Argentina.
              </p>
              <p className="text-[#eab308] font-bold" data-id="element-392">
                No es falta de vocación. Es falta de un sistema.
              </p>
            </div>
          </div>

          <div className="max-w-2xl mx-auto bg-[#111111] border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-393">
            <ul className="space-y-4" data-id="element-394">
              {PAIN_POINTS.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-395">
                  <span className="text-red-500 text-lg leading-none mt-0.5 flex-shrink-0" data-id="element-396">
                    ❌
                  </span>
                  <span className="text-gray-300 text-base md:text-lg leading-snug" data-id="element-397">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="mt-10 text-center" data-id="element-398">
            <p className="text-white font-serif italic text-xl md:text-2xl font-bold" data-id="element-399">
              ¿Y si este fuera el último día que postergás tu camino?
            </p>
          </div>
        </div>
      </div>
    </section>;
}